<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("report_order_return") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        v-if="isFullWms"
                        type="success"
                        size="sm"
                        @click="showMoveToMainModal = true"
                    >
                        <i class="fa fa-dolly"></i>
                        {{ $t("wms.return_move_main_button") }}
                    </base-button>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="row">
                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="startDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="endDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="paymentMethodType"
                                        :placeholder="$t('payment_method_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PaymentMethodTypeTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
								<base-input  >
								<el-select v-model="saleChannelType" :placeholder="$t('sale_channel')" filterable >
									<el-option
										v-for="option in SaleChannelTypeTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
                            </div>

						

                            <div class="col-auto">
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleSearch()"
                                >
                                    Search
                                </base-button>
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleDownload()"
                                >
                                    Export
                                </base-button>
                            </div>
                        </div>
						<div class="row">
							<div class="col-md-2">
								<base-input
								v-model="searchQuery"
								prepend-icon="fas fa-search"
								:placeholder="$t('search')"
							  >
							  </base-input>
							</div>
						</div>
                    </template>
                    <div>
						<div class="row">
							<div class="col ml-4" v-if="reportDatum != 0">
								รวม : {{ FormatCurrency(reportDatum)}}
							</div>

						</div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            @sort-change="sortChange"
                            @selection-change="selectionChange"
                        >
                            <el-table-column
                                v-for="column in tableColumns"
                                :key="column.label"
                                v-bind="column"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap "
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <return-move-to-main-modal :show.sync="showMoveToMainModal" />
    </div>
</template>
<script>

import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
  import { read, utils, writeFile } from 'xlsx'
import ReturnMoveToMainModal from "./ReturnMoveToMainModal";

export default {
    mixins: [clientPaginationMixin],
    components: {
        ReturnMoveToMainModal,
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Report/getReportOrderReturn",
            PaymentMethodTypeTable: "PaymentMethod/getPaymentMethodTypeTableWithAll",
            OrderStatusTable: "Order/OrderStatusTableWithAllPayment",
            reportDatum: "Report/getReportDatum",
            UserTable: "User/getData",
            isFullWms: "Auth/isFullWms",
        }),
		SaleChannelTypeTable(){
			return [
				{id:1,name:"บริษัท"},
				{id:2,name:"ตัวแทน"},
			]
		},
		OptionUserTable: function() {
			return [{ UserID: 0, fname: "-- พนักงาน --",lname:"" }, ...this.UserTable]
        },
		SaleChannelTypeTableWithAll(){
			return [{id:0,name:"-- ประเภทช่องทางการขาย -- "}].concat(this.SaleChannelTypeTable);
		},
        tableColumns: function() {
            return [
                {
                    prop: "wms_product_name",
                    label: this.$t("product_name"),
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "shipping_quantity",
                    label: this.$t("shipping_quantity"),
                    minWidth: 90,
                    sortable: true
                },
				{
                    prop: "return_good_quantity",
                    label: this.$t("return_good_quantity"),
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "return_broken_quantity",
                    label: this.$t("return_broken_quantity"),
                    minWidth: 100,
                    sortable: true
                },
                {
                    prop: "return_lost_quantity",
                    label: this.$t("return_lost_quantity"),
                    minWidth: 100,
                    sortable: true
                } ,
				{
                    prop: "return_other_reson_quantity",
                    label: this.$t("return_other_reson_quantity"),
                    minWidth: 100,
                    sortable: true
                } 
			];
        }
    },
    data() {
        return {
            propsToSearch: ["wms_product_name"],
            showMoveToMainModal: false,
            selectedRows: [],
            SearchData: "",
            startDate: "",
            endDate: "",
            paymentMethodType: 0,
            orderStatus: 0,
			saleChannelType:0,
			userId : 0,
        };
    },
    mounted() {

        this.startDate = moment().format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
        // this.handleSearch();
    },
    methods: {
        ...mapActions({
            listData: "Report/listReportOrderReturn",
            listUser: "User/listData",
        }),
        async handleSearch() {

			
            let params = {
                time_from: this.startDate,
                time_to: this.endDate,
            };
            await this.listData(params);
			this.sortChange({prop:"Cnt",order:""})
        },
		async handleDownload(index,row){

			let dataExport = this.tableData.map((item)=>{
				return {
                    "สินค้า" : item.wms_product_name,
                    "จำนวนที่จัดส่ง" : item.shipping_quantity,
                    "สินค้าดี" : item.return_good_qunatity,
                    "สินค้าชำรุด" : item.return_broken_quantity,	
                    "สินค้าสูญหาย" : item.return_lost_quantity,
                    "อื่นๆ" : item.return_other_reson_quantity,
                }
			})

			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,`return_${this.startDate}_${ this.endDate}.xlsx`)

		},

        handleDetail(index, row) {
            // this.$router.push("/wms/historydetail/" + row.ID);
            window.open("/#/wms/historydetail/" + row.ID);
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        }
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
